<script>
import { HorizontalBar } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';



const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export default {
  extends: HorizontalBar,
  props: ['options','height','data'],
  methods: {
    newData: function() {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.count,
            fill: true,
            backgroundColor: this.backgroundColor,
            borderColor: this.borderColor,
            borderWidth: 1,
            label: ""
          }
        ]},
        {
          layout: {
            padding: {
              right: 25, // espace pour les datalabels
            }
          },
          plugins: {
            datalabels: {
              anchor: 'end',
              align: 'end',
              offset:0
            }
          },
          tooltips: {enabled: false},
          responsive: true,
          // maintainAspectRatio: false,
          legend: {
            display: false
          },
          title: {
            display: true,
            fontSize: 20,
            text: 'Statut des plans'
          },
          // responsive: false,
          // Can't just just `stacked: true` like the docs say
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Fournisseurs (N='+this.sumFSS+')'
              },
              ticks: {min: 0},
            }]
          },
          animation: {
            duration: 500,
          },
        }
      )
    }
  },
  computed: {
    sortedData: function() {
      // Data
      var y = Object.assign({}, this.data);
      if(Object.keys(this.data).length > 0) {
        if(y[1]) y[1].colour='#f99a91'; // Non débuté
        if(y[2]) y[2].colour='#ecd374'; // En développement
        if(y[3]) y[3].colour='#878383'; // En mise-à-jour
        if(y[4]) y[4].colour='#18b358'; // soumis
        if(y[5]) y[5].colour='#399adb'; // Conforme
        if(y[6]) y[6].colour='#399adb'; // Non Conforme
        if(y[7]) y[7].colour='#18b358'; // en révision
        if(y[8]) y[8].colour='#399adb'; // Terminé
      }

      var output = Object.entries(y).map(([, value]) => (value));
      return output.sort((a,b) => (a.id > b.id) ? 1 : -1)
    },
    labels: function() {
      return this.sortedData.map(x => x.statut);
    },
    // datasets
    count: function() {
      return this.sortedData.map(x => x.count);
    },
    backgroundColor() {
      return this.sortedData.map(x => hex2rgba(x.colour,0.2));
    },
    borderColor() {
      return this.sortedData.map(x => x.colour);
    },
    sumFSS() {
      return this.count.reduce((a,b) => a + b, 0)
    }
  },
  components: {
    ChartDataLabels
  },
  watch: {
    data: function() {
      this.newData();
    }
  },
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.newData();
  }
}
</script>
